import { create } from "zustand";
import { PaletteMode } from "@mui/material";
import { persist } from "zustand/middleware";
import { ResetAction } from "data/@types/StoreUtils";

type State = {
  theme: PaletteMode;
};

const initialState: State = {
  theme: "light",
};

const useApplicationTweak = create(
  persist<State & ResetAction>(
    (set) => ({
      ...initialState,

      reset: () => set(initialState),
    }),
    {
      name: "application-tweak-storage",
    },
  ),
);

const switchTheme = () => {
  const theme = useApplicationTweak.getState().theme;
  useApplicationTweak.setState({ theme: theme === "dark" ? "light" : "dark" });
};

export { useApplicationTweak, switchTheme };
